import React, { createContext, useContext, useRef, useState } from "react";
import html2pdf from "html2pdf.js";


const PDFContext = createContext();

export const usePDF = () => useContext(PDFContext);

export const PDFProvider = ({ children }) => {
  const pdfRef = useRef();
  const [download,setDownload]=useState(false)
  const downloadPDF = () => {
    const element = pdfRef.current;

    const opt = {
      margin: [20, 8, 20, 8],
      filename: "Quotes_Policy.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(element).set(opt).save();
  };

  return (
    <PDFContext.Provider value={{ pdfRef, downloadPDF ,download,setDownload }}>
      {children}
    </PDFContext.Provider>
  );
};
